module.exports = __webpack_public_path__ + "img/TecnicoSena.3d525e50.png";